export default __webpack_public_path__ + "static/media/No46Open.5476d2de.jpg";